<div *ngIf="enableTab" class="widget" [class.loading-widget]="loading" [class.widget--no-data]="noData">
  <span class="widget__title" *ngIf="!isInPopup">
    <span>{{'Eval Overview' | translate | async}}</span>
    <i class="material-icons" [matTooltip]="'The current evaluation of all the equipment you can view based on their last inspection. Filter this data down using the search above. ' | translate | async">info</i>
    <i class="material-icons" [matTooltip]="'Enlarge ' | translate | async | translate | async" (click)="openWithANewPopup()">zoom_in</i>
  </span>
  <div [ngClass]="{'widget__content' : !isInPopup , 'large-widget' : isInPopup}">
    <div class="spinner-container" *ngIf="loading">
      <mat-spinner></mat-spinner>
    </div>
    <fusioncharts *ngIf="!loading" [hidden]="loading" [id]="chartid" [chartConfig]="chartconfig"  [width]="width" [height]="height"
     [type]="type" [dataFormat]="dataFormat" [dataSource]="dataSource"></fusioncharts>

  </div>
  <div class="widget__no-data" *ngIf="noData">
    <span>{{'You haven\'t set up any equipment yet. ' | translate | async}}</span>
  </div>
</div>
